module.exports = __webpack_public_path__ + "img/2.982443f2.png";